/**
 * ColorPickerButton registration: the parser, which reads the Button
 * properties plus `color`.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseColorPickerButton } from './parser';
const colorPickerButtonRegistration = {
    typeName: 'ColorPickerButton',
    parser: parseColorPickerButton,
};
nodeRegistry.register(colorPickerButtonRegistration);
//# sourceMappingURL=index.js.map